// SafetyAuditJsaTab.js
// Read-only JSA display for the Safety Audit's associated DEL.
//
// Uses the same JSA state/actions pattern as the DEL form: jsaFormUI state lives
// in the safety audit's Zustand store slice, and actions are composed from the
// shared makeJsaActions factory (parameterized with formKey="safetyAuditForm").
// This allows JSA sub-components to toggle sections and switch tabs (e.g.
// Employee/Non-Employee Signatures) while keeping the JSA data itself read-only
// (emitPatch is a no-op, so no socket patches are sent).

import React from "react";
import { JsaTab } from "../../jsaForm/JsaTab";
import styles from "./SafetyAuditJsaTab.module.css";

const noOp = () => {};

const SafetyAuditJsaTab = ({
  currentSafetyAudit,
  jsaLoading,
  jsaFormUI,
  jsaActions,
}) => {
  if (jsaLoading) {
    return <div className={styles.jsaLoading}>Loading JSA data...</div>;
  }

  if (!currentSafetyAudit.hasAssociatedJsa()) {
    return (
      <div className={styles.noJsa}>
        No JSA is associated with this safety audit.
        {currentSafetyAudit.hasAssociatedDel() && (
          <p>The associated DEL does not have a JSA.</p>
        )}
      </div>
    );
  }

  if (!currentSafetyAudit.jsaLoaded) {
    return <div className={styles.jsaLoading}>Loading JSA data...</div>;
  }

  // Build jsaProps the same way DelForm.js does, reading from the Zustand store
  const jsaProps = {
    allEmployees: [],
    delJsaEmployeeList: [],
    jsaData: currentSafetyAudit.jsa,
    jsaMode: "view",
    jsaVersion: currentSafetyAudit.jsa_version,
    jsaBase: jsaFormUI.base,
    jsaCore: jsaFormUI.core,
    jsaV1: jsaFormUI.v1,
    jsaV2: jsaFormUI.v2,
    emitPatch: noOp,
    autosaveErrors: { hasErrors: false, fieldErrors: {}, rowErrors: {} },
  };

  return (
    <div className={styles.jsaTabContainer}>
      <JsaTab jsaProps={jsaProps} actions={jsaActions} />
    </div>
  );
};

export default SafetyAuditJsaTab;